<template>
  <el-dialog :title="$t('activitiesSignUpManage.edit.title')" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-form-item :label="$t('activitiesSignUpManage.edit.userName')" prop="userName">
        <el-input v-model="form.userName" :placeholder="$t('activitiesSignUpManage.edit.userNamePlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('activitiesSignUpManage.table.userTel')" prop="userTel">
        <el-input v-model="form.userTel" :placeholder="$t('activitiesSignUpManage.edit.userTelPlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('activitiesSignUpManage.table.peopleCount')" prop="peopleCount">
        <el-input v-model.number="form.peopleCount" type="number" :placeholder="$t('activitiesSignUpManage.edit.peopleCountPlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('activitiesSignUpManage.table.stateName')" prop="state">
        <el-select v-model="form.state" :placeholder="$t('activitiesSignUpManage.edit.statePlaceholder')" style="width:100%">
          <el-option :key="10000" :value="'10000'" label="已报名" />
          <el-option :key="11000" :value="'11000'" label="已取消" />
          <el-option :key="12000" :value="'12000'" label="已完成" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { updateActivitiesSignUp } from '@/api/oa/activitiesSignUpManageApi'

export default {
  name: 'EditActivitiesSignUpView',
  data() {
    return {
      dialogVisible: false,
      form: {
        signUpId: '',
        activitiesId: '',
        userName: '',
        userTel: '',
        peopleCount: 1,
        state: '',
        communityId: ''
      },
      rules: {
        userName: [
          { required: true, message: this.$t('activitiesSignUpManage.validate.userNameRequired'), trigger: 'blur' },
          { max: 50, message: this.$t('activitiesSignUpManage.validate.userNameMaxLength'), trigger: 'blur' }
        ],
        userTel: [
          { required: true, message: this.$t('activitiesSignUpManage.validate.userTelRequired'), trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: this.$t('activitiesSignUpManage.validate.userTelFormat'), trigger: 'blur' }
        ],
        peopleCount: [
          { required: true, message: this.$t('activitiesSignUpManage.validate.peopleCountRequired'), trigger: 'blur' },
          { type:'number', min: 1,max:3, message: this.$t('activitiesSignUpManage.validate.peopleCountMin'), trigger: 'blur' }
        ],
        state: [
          { required: true, message: this.$t('activitiesSignUpManage.validate.stateRequired'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
        this.form = {
          signUpId: row.signUpId,
          activitiesId: row.activitiesId,
          userName: row.userName,
          userTel: row.userTel,
          peopleCount: +row.peopleCount,
          state: String(row.state || '10000'),
          communityId: row.communityId || getCommunityId()
        }
      })
    },
    buildSubmitPayload() {
      return {
        signUpId: this.form.signUpId,
        userName: this.form.userName,
        userTel: this.form.userTel,
        peopleCount: this.form.peopleCount,
        state: String(this.form.state),
        communityId: getCommunityId()
      }
    },
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await updateActivitiesSignUp(this.buildSubmitPayload())
            this.$message.success(this.$t('common.operationSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          } catch (error) {
            console.error('更新活动报名失败:', error)
            this.$message.error(error.message || '更新活动报名失败')
          }
        }
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    }
  }
}
</script>